import {
  Box,
  Checkbox,
  HStack,
  Input,
  InputGroup,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Tag,
  TagLabel,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import FocusLock from 'react-focus-lock';

import { PopoverMenuItem, PopoverMenuList } from './PopoverMenu';
import { SelectButton } from './SelectButton';

interface Option {
  label: string;
  value: string;
  id: string;
}

interface MultiSelectDropdownProps {
  options: Option[];
  value: string[];
  onChange: (selectedValues: string[]) => void;
  placeholder?: string;
  maxHeight?: string;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select',
  maxHeight = '200px',
}) => {

  const firstFieldRef = React.useRef(null);
  const updateSelection = (selectedTag: string) => {
    if (value?.includes(selectedTag)) {
      return value?.filter((tag) => tag !== selectedTag);
    } else {
      return value ? [...value, selectedTag] : [selectedTag];
    }
  };
  return (
    <Popover initialFocusRef={firstFieldRef} matchWidth>
      <PopoverTrigger>
        <SelectButton w="full">
          {value && value.length > 0 ? (
            <HStack>
              {value.map((tag) => {
                const tagValue = options.find((option) => option.id === tag);
                return (
                  <Tag key={tag} variant="solid">
                    <TagLabel>{tagValue?.label}</TagLabel>
                  </Tag>
                );
              })}
            </HStack>
          ) : (
            'Select Tags'
          )}
        </SelectButton>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="full" shadow="lg" maxHeight={56} overflow="auto">
          <FocusLock returnFocus persistentFocus={false}>
            <PopoverMenuList>
              {options?.map((tag) => {
                return (
                  <PopoverMenuItem
                    key={tag.id}
                    onClick={() => onChange(updateSelection(tag?.id || ''))}
                    isChecked={value && value?.includes(tag.id)}
                  >
                    {tag.label}
                  </PopoverMenuItem>
                );
              })}

              {options?.length === 0 && (
                <Text
                  color="gray.500"
                  padding="2"
                  textStyle="compact"
                  textAlign="center"
                >
                  No matching search results
                </Text>
              )}
            </PopoverMenuList>
          </FocusLock>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default MultiSelectDropdown;
